var _line, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDividerOr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 539,
    height: 29,
    viewBox: "0 0 539 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.74228e-8,
    y1: 17,
    x2: 539,
    y2: 17,
    stroke: "#FF9FD4",
    strokeWidth: 2,
    strokeDasharray: "20 20"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 4,
    width: 76,
    height: 24,
    fill: "#807BE4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270.234 13.3149C269.097 12.2813 267.703 11.7755 266.075 11.7755C264.469 11.7755 263.047 12.2813 261.852 13.3149C260.658 14.3265 260.026 15.734 259.976 17.5373C259.926 19.3406 260.481 20.7481 261.618 21.7817C262.756 22.7933 264.151 23.2991 265.757 23.2991C267.385 23.2991 268.806 22.7933 270 21.7817C271.217 20.7481 271.85 19.3406 271.9 17.5373C271.95 15.734 271.394 14.3265 270.234 13.3149ZM263.652 19.8464C263.052 19.2526 262.766 18.4829 262.792 17.5373C262.818 16.5917 263.147 15.822 263.779 15.2502C264.411 14.6564 265.145 14.3705 266.003 14.3705C266.861 14.3705 267.601 14.6564 268.201 15.2502C268.823 15.822 269.11 16.5917 269.084 17.5373C269.058 18.4829 268.728 19.2526 268.074 19.8464C267.442 20.4182 266.686 20.7041 265.828 20.7041C264.97 20.7041 264.252 20.4182 263.652 19.8464ZM281.831 11.9075C281.569 11.8195 281.262 11.7755 280.888 11.7755C279.546 11.7755 278.515 12.4572 277.796 13.8207L277.844 12.0834H275.072L274.77 22.9912H277.542L277.691 17.6033C277.744 15.69 278.77 14.3705 280.42 14.3705C280.75 14.3705 281.035 14.4145 281.318 14.5245L281.831 11.9075Z",
    fill: "#FF9FD4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerOr);
export default __webpack_public_path__ + "static/media/divider_or.a44f29d71ddf25097b2cee9d42dd61cf.svg";
export { ForwardRef as ReactComponent };